import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Wrapper from '../../components/wrapper';
import './styles.css';

/**
 *  CarNavigationLinkItem
 */
class CarNavigationLinkItem extends Component {
  static propTypes = {
    containerId: PropTypes.string,
    containerClass: PropTypes.string,
    type: PropTypes.string,
    label: PropTypes.string,
    url: PropTypes.string,
    external: PropTypes.bool,
    pcSrc: PropTypes.string,
    mbSrc: PropTypes.string,
    number: PropTypes.number
  };
  static defaultProps = {
    containerId: null,
    containerClass: null,
    type: null,
    label: null,
    url: null,
    external: null,
    pcSrc: null,
    mbSrc: null,
    number: null
  };
  
  constructor(props) {
    super();
    this.props = props;
  }
  
  render() {
    const {
      containerId,
      containerClass,
      type,
      label,
      url,
      external,
      pcSrc,
      mbSrc,
      number
    } = this.props;
        
    //
    return (
      <Wrapper
        containerId={containerId}
        containerClass={containerClass}
      >
        <div className='CarNavigationLinkItem'>
        {(() => {
          if((pcSrc && pcSrc !=='') || (mbSrc && mbSrc !=='')){
            let mbSrcFix = mbSrc ? mbSrc : pcSrc;
            return(
              <div className='CarNavigationLinkItem__container CarNavigationLinkItem__container--image'>
                <a 
                  href={url && url !== '' ? url : null} 
                  target={external ? '_blank' : null} 
                  className='CarNavigationLinkItem__container__link'
                >
                  <div className="CarNavigationLinkItem__container__link__image__container">
                    <img src={pcSrc} className="CarNavigationLinkItem__container__link__image CarNavigationLinkItem__container__link__image--pc" />
                    <img src={mbSrcFix} className="CarNavigationLinkItem__container__link__image CarNavigationLinkItem__container__link__image--mb" />
                  </div>
                  {label && label !== '' ? <span className="CarNavigationLinkItem__container__link__label">{label}</span> : ''}
                </a>
              </div>
            )
          }
          else{
            return(
              <div className='CarNavigationLinkItem__container CarNavigationLinkItem__container--noimage'>
                <a 
                  href={url && url !== '' ? url : null} 
                  target={external ? '_blank' : null} 
                  className='CarNavigationLinkItem__container__link'
                >
                  {label && label !== '' ? <span className="CarNavigationLinkItem__container__link__label"><span className="CarNavigationLinkItem__container__link__label__text">{label}</span></span> : ''}
                </a>
              </div>
            )
          }
        })()}
        </div>
      </Wrapper>
    )
  }
  
}

export default CarNavigationLinkItem;



// WEBPACK FOOTER //
// ./src/containers/car-navigation-link-item/index.jsx